import {

    PROJECT_LIST_REQUEST,
    PROJECT_LIST_SUCCESS,
    PROJECT_LIST_FAIL,

    
    GET_PROJECT_REQUEST,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAIL,
   
    
    ADD_PROJECT_REQUEST,
    ADD_PROJECT_SUCCESS,
    ADD_PROJECT_FAIL,
  
    
    RENAME_PROJECT_REQUEST,
    RENAME_PROJECT_SUCCESS,
    RENAME_PROJECT_FAIL,
    RENAME_PROJECT_RESET,
    
    DELETE_PROJECT_REQUEST ,
    DELETE_PROJECT_SUCCESS,
    DELETE_PROJECT_FAIL,
    DELETE_PROJECT_RESET,
    
    
    ADD_PROJECT_LINK_REQUEST,
    ADD_PROJECT_LINK_SUCCESS,
    ADD_PROJECT_LINK_FAIL,
    ADD_PROJECT_LINK_RESET,
    
    EDIT_PROJECT_LINK_REQUEST,
    EDIT_PROJECT_LINK_SUCCESS,
    EDIT_PROJECT_LINK_FAIL,
    EDIT_PROJECT_LINK_RESET,
    
    DELETE_PROJECT_LINK_REQUEST,
    DELETE_PROJECT_LINK_SUCCESS,
    DELETE_PROJECT_LINK_FAIL,
    DELETE_PROJECT_LINK_RESET,
    
    ADD_PROJECT_TASK_REQUEST,
    ADD_PROJECT_TASK_SUCCESS,
    ADD_PROJECT_TASK_FAIL,
    ADD_PROJECT_TASK_RESET,
    
    EDIT_PROJECT_TASK_REQUEST,
    EDIT_PROJECT_TASK_SUCCESS,
    EDIT_PROJECT_TASK_FAIL,
    EDIT_PROJECT_TASK_RESET,
    
    DELETE_PROJECT_TASK_REQUEST,
    DELETE_PROJECT_TASK_SUCCESS,
    DELETE_PROJECT_TASK_FAIL,
    DELETE_PROJECT_TASK_RESET,
    
    CLEAR_PROJECT_DONE_TASKS_REQUEST,
    CLEAR_PROJECT_DONE_TASKS_SUCCESS,
    CLEAR_PROJECT_DONE_TASKS_FAIL,
    CLEAR_PROJECT_DONE_TASKS_RESET,
    
    ADD_PROJECT_LIST_REQUEST,
    ADD_PROJECT_LIST_SUCCESS,
    ADD_PROJECT_LIST_FAIL,
    ADD_PROJECT_LIST_RESET,
    
    
    RENAME_PROJECT_LIST_REQUEST,
    RENAME_PROJECT_LIST_SUCCESS,
    RENAME_PROJECT_LIST_FAIL,
    RENAME_PROJECT_LIST_RESET,
    
    ADD_PROJECT_LIST_ITEM_REQUEST,
    ADD_PROJECT_LIST_ITEM_SUCCESS,
    ADD_PROJECT_LIST_ITEM_FAIL,
    ADD_PROJECT_LIST_ITEM_RESET,
    
    TOGGLE_PROJECT_LIST_ITEM_REQUEST,
    TOGGLE_PROJECT_LIST_ITEM_SUCCESS,
    TOGGLE_PROJECT_LIST_ITEM_FAIL,
    TOGGLE_PROJECT_LIST_ITEM_RESET,
    
    DELETE_PROJECT_LIST_ITEM_REQUEST,
    DELETE_PROJECT_LIST_ITEM_SUCCESS,
    DELETE_PROJECT_LIST_ITEM_FAIL,
    DELETE_PROJECT_LIST_ITEM_RESET,
    
    DELETE_PROJECT_LIST_REQUEST,
    DELETE_PROJECT_LIST_SUCCESS,
    DELETE_PROJECT_LIST_FAIL,
    DELETE_PROJECT_LIST_RESET,
    
    
    SAVE_PROJECT_NOTE_REQUEST,
    SAVE_PROJECT_NOTE_SUCCESS,
    SAVE_PROJECT_NOTE_FAIL,
    SAVE_PROJECT_NOTE_RESET,
    

} from '../constants/projectsConstants'
import { axiosAuthed } from "../auth/createAuthedAxios.ts";



export const getProjectsList = () => async (dispatch, getState) => {

    try {
        dispatch({
            type: PROJECT_LIST_REQUEST
        })

        const config = {
            headers: {
                'accept': 'application/json',
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/`

        const {data} = await axiosAuthed.get(

            url,
            config
        )

        dispatch({
            type: PROJECT_LIST_SUCCESS,
            payload: data
        })
        console.log(data)

    } catch (error) {
        dispatch({
            type: PROJECT_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const addProject = (project) => async (dispatch, getState) => {
  console.log(project)
    try {
        dispatch({
            type: ADD_PROJECT_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                // //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/`

        const { data } = await axiosAuthed.post(

            url,
            project,
            config
        )


        dispatch({
            type: ADD_PROJECT_SUCCESS,
            payload: data
        })
        dispatch(getProjectsList())

    } catch (error) {
        dispatch({
            type: ADD_PROJECT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const getProject = (project_id) => async (dispatch, getState) => {


    try {
        dispatch({
            type: GET_PROJECT_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${project_id}`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: GET_PROJECT_SUCCESS,
            payload: data
        })
       
     



    } catch (error) {
        dispatch({
            type: GET_PROJECT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const renameProject = (projectId, title) => async (dispatch, getState) => {


    try {
        dispatch({
            type: RENAME_PROJECT_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}`

        const { data } = await axiosAuthed.put(

            url,
            title,
            config
        )

        dispatch({
            type: RENAME_PROJECT_SUCCESS,
            payload: data
        })
        dispatch(getProjectsList())

     
    } catch (error) {
        dispatch({
            type: RENAME_PROJECT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const deleteProject = (project_id) => async (dispatch, getState) => {


    try {
        dispatch({
            type: DELETE_PROJECT_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${project_id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_PROJECT_SUCCESS,
            payload: data
        })
        dispatch(getProjectsList())



    } catch (error) {
        dispatch({
            type: DELETE_PROJECT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const addProjectLink = (link) => async (dispatch, getState) => {


    try {
        dispatch({
            type: ADD_PROJECT_LINK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${link.project_id}/links`

        const { data } = await axiosAuthed.post(

            url,
            link,
            config
        )


        dispatch({
            type: ADD_PROJECT_LINK_SUCCESS,
            payload: data
        })
        dispatch(getProject(link.project_id))

    } catch (error) {
        dispatch({
            type: ADD_PROJECT_LINK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const editProjectLink = (link) => async (dispatch, getState) => {

    try {
        dispatch({
            type: EDIT_PROJECT_LINK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${link.project_id}/links/${link.id}`

        const { data } = await axiosAuthed.put(

            url,
            link,
            config
        )


        dispatch({
            type: EDIT_PROJECT_LINK_SUCCESS,
            payload: data
        })
        dispatch(getProject(link.project_id))

    } catch (error) {
        dispatch({
            type: EDIT_PROJECT_LINK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const deleteProjectLink = (link) => async (dispatch, getState) => {
    
    try {
        dispatch({
            type: DELETE_PROJECT_LINK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${link.project_id}/links/${link.id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_PROJECT_LINK_SUCCESS,
            payload: data
        })
        dispatch(getProject(link.project_id))

    } catch (error) {
        dispatch({
            type: DELETE_PROJECT_LINK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const addProjectTask = (projectId, task) => async (dispatch, getState) => {
    
    try {
        dispatch({
            type: ADD_PROJECT_TASK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/tasks`

        const { data } = await axiosAuthed.post(

            url,
            task,
            config
        )


        dispatch({
            type: ADD_PROJECT_TASK_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: ADD_PROJECT_TASK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const editProjectTask = (projectId, task) => async (dispatch, getState) => {
    
    try {
        dispatch({
            type: EDIT_PROJECT_TASK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/tasks/${task.id}`

        const { data } = await axiosAuthed.put(

            url,
            task,
            config
        )


        dispatch({
            type: EDIT_PROJECT_TASK_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: EDIT_PROJECT_TASK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const deleteProjectTask = (projectId, task) => async (dispatch, getState) => {

    try {
        dispatch({
            type: DELETE_PROJECT_TASK_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/tasks/${task.id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_PROJECT_TASK_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: DELETE_PROJECT_TASK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const clearProjectDoneTasks = (projectId) => async (dispatch, getState) => {

    try {
        dispatch({
            type: CLEAR_PROJECT_DONE_TASKS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/tasks`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: CLEAR_PROJECT_DONE_TASKS_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: CLEAR_PROJECT_DONE_TASKS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const addProjectList = (projectId,list) => async (dispatch, getState) => {

    try {
        dispatch({
            type: ADD_PROJECT_LIST_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists`

        const { data } = await axiosAuthed.post(

            url,
            list,
            config
        )


        dispatch({
            type: ADD_PROJECT_LIST_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: ADD_PROJECT_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const renameProjectList = (projectId,list) => async (dispatch, getState) => {

    try {
        dispatch({
            type: RENAME_PROJECT_LIST_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists/${list.id}`

        const { data } = await axiosAuthed.put(

            url,
            list,
            config
        )


        dispatch({
            type: RENAME_PROJECT_LIST_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: RENAME_PROJECT_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const deleteProjectList = (projectId, list) => async (dispatch, getState) => {

    try {
        dispatch({
            type: DELETE_PROJECT_LIST_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists/${list.id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_PROJECT_LIST_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: DELETE_PROJECT_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const addProjectListItem = (projectId, listItem) => async (dispatch, getState) => {
    
    try {
        dispatch({
            type: ADD_PROJECT_LIST_ITEM_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists/${listItem.list_id}/items`

        const { data } = await axiosAuthed.post(

            url,
            listItem,
            config
        )


        dispatch({
            type: ADD_PROJECT_LIST_ITEM_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: ADD_PROJECT_LIST_ITEM_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const toggleProjectListItem = (projectId, listItem) => async (dispatch, getState) => {

    try {
        dispatch({
            type: TOGGLE_PROJECT_LIST_ITEM_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists/${listItem.list_id}/items/${listItem.id}`

        const { data } = await axiosAuthed.put(

            url,
            listItem,
            config
        )


        dispatch({
            type: TOGGLE_PROJECT_LIST_ITEM_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: TOGGLE_PROJECT_LIST_ITEM_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const deleteProjectListItem = (projectId, listItem) => async (dispatch, getState) => {

    try {
        dispatch({
            type: DELETE_PROJECT_LIST_ITEM_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/lists/${listItem.list_id}/items/${listItem.id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_PROJECT_LIST_ITEM_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: DELETE_PROJECT_LIST_ITEM_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const saveProjectNote = (projectId, note) => async (dispatch, getState) => {
    console.log(note)
    try {
        dispatch({
            type: SAVE_PROJECT_NOTE_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}projects/${projectId}/note`

        const { data } = await axiosAuthed.put(

            url,
            note,
            config
        )


        dispatch({
            type: SAVE_PROJECT_NOTE_SUCCESS,
            payload: data
        })
        dispatch(getProject(projectId))

    } catch (error) {
        dispatch({
            type: SAVE_PROJECT_NOTE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

